import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { Subscription } from 'rxjs';
import { SAML2Config } from '../models/saml2_config';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { FindIdP } from '../models/find_idp';
import { controlErrors } from '../shared/app.validators';
import { SAML2Attribute } from '../models/saml2_attribute';

@Component({
  selector: 'app-idp-config',
  styles: [],
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div class="col-lg-3 col-md-12 col-xs-12">
        <form [formGroup]="form" novalid>
            <!-- SINGLE SIGN-ON -->
            <p style='color: #919191;'>Single Sign-On</p>
            <div class="customHr" style="width:150px">.</div>
        
            <div class="form-group">
                <p class="custom-label">Entity ID</p>
                <input type="text" [(ngModel)]="data.sso.idpEntityId" formControlName="entityId" class="form-control" placeholder="Entity ID" title="Entity ID">
            </div>

            <div class="form-group">
                <p class="custom-label">Login URL</p>
                <input type="text" [(ngModel)]="data.sso.idpLoginUrl" formControlName="idpLoginUrl" class="form-control" placeholder="Login URL" title="Login URL">
            </div>

            <div class="form-group">
                <p class="custom-label">Logout URL</p>
                <input type="text" [(ngModel)]="data.sso.idpLogoutUrl" formControlName="idpLogoutUrl" class="form-control" placeholder="Logout URL" title="Logout URL">
            </div>

            <div class="form-group">
                <label class="custom-label">IdP Public Certificate</label>
                <textarea style="width:auto;" class="form-control" [(ngModel)]="data.sso.idpPublicCertificate" formControlName="idpPublicCertificate" placeholder="IdP Public Certificate" title="IdP Public Certificate" rows="4" cols="80"></textarea>
            </div>

            <!-- POLICY -->
            <p style='color: #919191;'>Policy</p>
            <div class="customHr" style="width:150px">.</div>

            <div class="form-group" style="width:2000px!important">
                <label class="custom-label">Manage User Profile - If on then new user profile will be created once they login and keep updating profile every other login, if unchecked then new users will not be created and they can not login, except existing users.</label><br/>
                <app-toggle [(toggle)]="data.policy.manageUserProfile"></app-toggle>
            </div>

            <div class="form-group" style="width:2000px!important">
                <label class="custom-label">Roles Mapping - If checked, then all users have to be validated by role mapping area, each user must have groups in order to login, if unchecked then manual user role has to be created.</label><br/>
                <app-toggle [(toggle)]="data.policy.rolesMapping"></app-toggle>
            </div>
            
            <!-- ATTRIBUTES -->
            <p style='color: #919191;'>Attributes</p>
            <div class="customHr" style="width:150px">.</div>
            <a style="cursor:pointer;" (click)="addAttribute()">Add Attribute</a>

            <div class="card" style="margin-top:20px;">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Attribute Label</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data.attributes; let i = index">
                            <td style="width:60%;">{{ row.label }}</td>
                            <td style="width:40%;">
                                <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="editAttribute(i)">Edit</span> |
                                <span title="Remove Attribute" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeAttribute(i)" style="cursor:pointer;"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-top:25px;">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
        </form>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  `,
})
export class IdPConfigComponent implements OnInit {
    idp: IdP;
    msg: Alert;
    msgHead: Alert;
    acctNumber: string;
    hasAccess: boolean;
    idParam: string;
    nameQueryParam: string;
    private subscriptionQueryParams: Subscription;
    data: SAML2Config;
    form: FormGroup;

    constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router, fb: FormBuilder) {
        this.hasAccess = true;
        this.msg = new Alert();
        this.msgHead = new Alert();
        title.setTitles({
            title: 'Config - Identity Provider',
            dashboard: 'Config - Identity Provider'
        });
        this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.nameQueryParam = params['name'];
			}
        );
        this.idp = new IdP();
        this.data = new SAML2Config();

        this.form = fb.group({
			entityId: ['', Validators.compose([Validators.required])],
			idpLoginUrl: ['', Validators.compose([Validators.required])],
            idpLogoutUrl: [''],
            idpPublicCertificate: ['', Validators.compose([Validators.required])],
        });
    }

    addAttribute() {
        this.router.navigate([`idp/${this.acctNumber}/idps/${this.idParam}/config/attributes/add`], { queryParams: { name: this.nameQueryParam } });
        return;
    }

    editAttribute(inx: number) {
        this.router.navigate([`idp/${this.acctNumber}/idps/${this.idParam}/config/attributes/${inx+1}/edit`], { queryParams: { name: this.nameQueryParam } });
        return;
    }

    removeAttribute(inx: number) {
        if (inx >= 0) {
            this.data.attributes.splice(inx, 1);
            return;
        }
    }

    ngOnInit() {
        this.idParam = this.activatedRoute.snapshot.params['id'];
        this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
        if (this.acctNumber != null) {
            this.idsvc.validateAcctNumber(this.acctNumber)
                .subscribe(res => {
                    if (!res) {
                        this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
                        this.hasAccess = false;
                    }
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                    this.hasAccess = false;
                })
        }
        this.title.setBreadcrumbs([
            { title: 'Identity Providers ', link: `/idp/${this.acctNumber}/idps` },
            { title: decodeURIComponent(this.nameQueryParam) + ' ', link: `/idp/${this.acctNumber}/idps/${this.idParam}/edit` },
            { title: 'Config ', link: `` }
        ]);
        this.loadData();
    }

    loadData() {
        let req = new FindIdP();
        req.id = parseInt(this.idParam);
        this.idsvc.saml2ConfigApi(this.acctNumber, req)
            .subscribe((saml2cfg: SAML2Config) => {
                this.data = saml2cfg;
            }, err => {
                console.log(err);
                if (this.idsvc.isErrNotFound(err)) {
                this.msg.warning(this.idsvc.getUserError(err));
                } else {
                    if (this.idsvc.isErrUnauthorized(err)) {
                        this.hasAccess = false;
                        this.msg.error(this.idsvc.getUserErrorDefault(err));
                    } else {
                        this.msg.error(this.idsvc.getUserErrorDefault(err));
                    }
                }
            });
    }

    save() {
        if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
        }
        this.data.sso.idpEntityId = this.form.get('entityId').value;
        this.data.sso.idpLoginUrl = this.form.get('idpLoginUrl').value;
        this.data.sso.idpLogoutUrl = this.form.get('idpLogoutUrl').value;
        this.data.sso.idpPublicCertificate = this.form.get('idpPublicCertificate').value;

        this.idsvc.saveSaml2ConfigApi(this.acctNumber, parseInt(this.idParam), this.data)
			.subscribe(res => {
                this.router.navigate([`idp/${this.acctNumber}/idps`]);
		        return;
            }, err => {
                console.log(err);
                let e = this.idsvc.getUserErrorDefault(err);
                this.msgHead.error(e);
            });
    }

    displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

    goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idps/${this.idParam}/edit`]);
		return;
	}
}
